// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useQuery, useNavigationDOM} from '@supermove/hooks';

// App
import ProjectWidgetKind from '@shared/modules/Project/enums/ProjectWidgetKind';
import SalesPageContent from '@shared/modules/Sales/components/SalesPageContent';
import SidebarPageV2 from 'modules/App/components/SidebarPageV2';

const SalesPage = () => {
  const {navigator, params} = useNavigationDOM();
  const {data} = useQuery(SalesPage.query, {
    fetchPolicy: 'cache-and-network',
    variables: {
      projectUuid: params.projectUuid ?? '',
    },
  });

  return (
    <SidebarPageV2 selected={'sales'}>
      <SalesPageContent
        projectPaneWidgets={
          data?.project?.isStorage
            ? [ProjectWidgetKind.DOCUMENTS, ProjectWidgetKind.COMMENTS]
            : [
                ProjectWidgetKind.PROJECT_DETAILS,
                ...(data?.viewer.viewingOrganization.features
                  .isEnabledProjectPaneProjectDetailsBlocks
                  ? [
                      ProjectWidgetKind.JOB_DETAILS,
                      ProjectWidgetKind.CONVERSATIONS,
                      ProjectWidgetKind.TASKS,
                      ProjectWidgetKind.DOCUMENTS,
                      ProjectWidgetKind.ATTACHMENTS,
                      ProjectWidgetKind.WORKFLOWS,
                    ]
                  : [ProjectWidgetKind.CONVERSATIONS]),
                ProjectWidgetKind.COMMENTS,
                ProjectWidgetKind.EVENT_LOG,
              ]
        }
        tab={params.tab}
        handlePressTab={(tab) => {
          if (tab !== params.tab) {
            navigator.push(`/sales/${tab}`);
          }
        }}
      />
    </SidebarPageV2>
  );
};

export default SalesPage;

// --------------------------------------------------
// Data
// --------------------------------------------------
SalesPage.query = gql`
  query SalesPage($projectUuid: String!) {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
        features {
          isEnabledProjectPaneProjectDetailsBlocks: isEnabled(feature: "PROJECT_PANE_PROJECT_DETAILS_BLOCKS")
        }
      }
    }
    project(uuid: $projectUuid) {
      id
      isStorage
    }
  }
`;
